import environment from 'environment';
import { getRequest, postRequest } from '..';

const { SHIPSTATION_BASE_URL } = environment.eCommerce;

export const shipstationGetQuery = getRequest(SHIPSTATION_BASE_URL);
export const shipstationCreateReturnLabelForShopifyOrder = postRequest(SHIPSTATION_BASE_URL);
